'use strict';

angular.module('AcaApp').controller('ImportController', [
  '$scope',
  '$mdDialog',
  '$route',
  '$timeout',
  '$location',
  '$window',
  'SETTINGS',
  'ImportService',
  'MetaService',
  'AuxiliaryOperationsService',
  '$q',
  'UtilsService',
  '$rootScope',
  'HIST_STATUS_TEXT',
  'LayoutService',
  'LRJ_MANAGER',
  'AuxiliaryDataService',
  'ManagedUserInformationService',
  'RFMService',
  '$filter',
  'CONSTANTS',
  'FORM_MESSAGES',
  'IMPORT',
  function(
    $scope,
    $mdDialog,
    $route,
    $timeout,
    $location,
    $window,
    SETTINGS,
    ImportService,
    MetaService,
    AuxiliaryOperationsService,
    $q,
    UtilsService,
    $rootScope,
    HIST_STATUS_TEXT,
    LayoutService,
    LRJ_MANAGER,
    AuxiliaryDataService,
    ManagedUserInformationService,
    RFMService,
    $filter,
    CONSTANTS,
    FORM_MESSAGES,
    IMPORT
  ){
    var selectAMap = '- Select a Map -';
    ManagedUserInformationService.checkManagedServices('import');
    $scope.options = {};
    $scope.options.importMaps = [];
    $scope.importMapsForClone = [];
    $scope.options.importMapNames = [];
    $scope.options.mapComboDisabled = true;
    $scope.options.mapEditButtonDisabled = true;
    $scope.options.mapUpdEditButtonDisabled = true;
    $scope.options.importResultData = [];
    $scope.options.labelMapName = selectAMap;
    $scope.options.labelMapUpdName = selectAMap;
    $scope.options.labelMapStandardName = selectAMap;
    $scope.options.labelCloneMapName = selectAMap;
    $scope.rejectRecords = false;
    $scope.selectedMapFchar = {
      participant: true,
      form: 'X5B',
      employer: true
    };
    $scope.messageError = '';
    $scope.fileType = '~IMPORT~';
    $scope.showRequired = false;
    var filterFields = [
      'depssn', 'depname', 'depdateofbirth', 'distcode', 'auxdescription3', 'submissionid', 'info1', 'auxdescription2', 'groupstatus',
      'receiptid', 'recordid', 'auxdescription1', 'info3', 'warnings', 'auxdescription4', 'rerunno', 'indicator1', 'userdefined1',
      'indicator2', 'userdefined2', 'indicator3', 'userdefined3', 'indicator4', 'userdefined4', 'userdefined5', 'pcode', 'pgroupno',
      'auxcmbbox1', 'auxcmbbox2', 'auxcmbbox3'
    ];
    var isNewEmployerSponsorMapped = 'N';
    var getStoredMapNames = function(){
      $scope.importMapsForClone = [];
      $scope.options.importMapsStandard = [];
      $scope.options.importMapsCustom = [];
      $scope.options.importMapsUpdate = [];
      ImportService.getStoredMapNames().then(function(data){
        $scope.options.importMaps = data.result;
        if($scope.mode){
          setMapAsCustomSelected();
        }
        data.result.forEach(function(map, index, mapList){
          if(mapList[index].FullName.substr(0, 16) === SETTINGS.STANDARDMAPS){
            $scope.options.importMapsStandard.push(map);
          }
          else{
            if(mapList[index].SettingName.substr(0,14) === SETTINGS.CORRECTIONMAPS){
              mapList[index].SettingName = mapList[index].SettingName.substr(14);
              $scope.options.importMapsUpdate.push(map);
            }
            else{
              $scope.options.importMapsCustom.push(map);
            }
          }
          $scope.importMapsForClone.push(map);
        });
      });
    };

    var setMapAsCustomSelected = function(){
      var mapElement = _.find($scope.options.importMaps, function(map){
        if($scope.options.newData !== 'false'){
          return ($scope.options.mapName === map.SettingName);
        }
        else{
          return (("CORRECTIONMAP." + $scope.options.mapName) === map.SettingName);
        }
      });
      if($scope.options.newData !== 'false'){
        $scope.options.selectedMap = mapElement.FullName;
        $scope.options.selectedMapUpdate = undefined;
        $scope.selectMapName(IMPORT.ORIGINALIMPORT);
      }
      else{
        $scope.options.selectedMap = undefined;
        $scope.options.selectedMapUpdate = mapElement.FullName;
        $scope.selectMapName(IMPORT.UPDATEIMPORT);
      }
    };

    var findMapElement = function(){
      var mapElement = _.find($scope.options.importMaps, function(map){
        return ($scope.options.selectedMap === map.FullName || $scope.options.selectedMapStandard === map.FullName || $scope.options.selectedMapUpdate === map.FullName || $scope.options.selectedMapForClone === map.FullName);
      });
      return mapElement;
    };

    getStoredMapNames();

    $scope.filterMetaFields = function(metaArray){
      return filterFields.indexOf(metaArray.name) === -1;
    };

    //TODO: Who is sending wich table is being mapped?
    var withoutParticipantDescription = 'Account No. is required in order to assign your form data to the correct participant';

    $scope.prepareDestinationFields = function(){
      $scope.destinationFields = [];
      var participantFields = [
        {name: 'Participant Identifier:', header: true, type: 'WithoutParticipant'},
        {name: 'Social Security Number *', fname: 'TIN', type: 'Mandatory', ftype: 'STRING'},
        {name: 'Account no *', fname: 'ACCOUNTNO', type: 'Mandatory', ftype: 'STRING'},
        {name: 'GML', fname: 'GML', type: 'Mandatory', ftype: 'STRING'},
        {name: 'New TIN', fname: 'GRIDENTIFICATIONNUM', type: 'Mandatory', ftype: 'STRING'},
        {name: withoutParticipantDescription, description: true, type: 'WithoutParticipant'}
      ];
      Array.prototype.push.apply($scope.destinationFields, participantFields);
      var promisePayee = MetaService.getMetaByFchar('1');
      var promisePayer = MetaService.getMetaByFchar('0');
      var promiseX5B = MetaService.getMetaByFchar('X5B');
      var promiseX5C = MetaService.getMetaByFchar('X5C');
      $q.all(
        [
          promisePayee,
          promisePayer,
          promiseX5B,
          promiseX5C
        ]).then(function(data){
        _.each(data, function(metadata){
          metadata.meta = angular.fromJson(metadata.JsonData);
          metadata.meta = metadata.meta.filter($scope.filterMetaFields);
        });

        $scope.destinationFields.push({name: 'Participant:', header: true, type: 'Participant', ftype: 'STRING'});
        pushMetadataInDestinationFields(data[0], 'Participant');

        $scope.destinationFields.push({name: 'Employer:', header: true, type: 'Employer', ftype: 'STRING'});
        pushMetadataInDestinationFields(data[1], 'Employer');

        $scope.destinationFields.push({name: '1095-B:', header: true, type: 'X5B'});
        pushMetadataInDestinationFields(data[2], 'X5B');

        $scope.destinationFields.push({name: '1095-C:', header: true, type: 'X5C'});
        pushMetadataInDestinationFields(data[3], 'X5C');
      });
    };

    var pushMetadataInDestinationFields = function(metadata, type){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      Array.prototype.push.apply($scope.destinationFields, _.map(metadata.meta, function(infoMeta){
          return {
            name: UtilsService.addAsteriskForRequiredField(infoMeta),
            fname: infoMeta.model,
            ftype: infoMeta.data_type,
            type: type
          };
        })
      );
    };

    $scope.prepareDestinationFields();

    $scope.selectMapName = function(importType){
      $scope.options.mapComboDisabled = ($scope.options.selectedMap !== '' && $scope.options.selectedMap !== null);
      $scope.options.mapEditButtonDisabled = ($scope.options.selectedMap == '' || $scope.options.selectedMap == null);
      $scope.options.mapUpdEditButtonDisabled = ($scope.options.selectedMapUpdate == '' || $scope.options.selectedMapUpdate == null);
      if($scope.options.selectedMap || $scope.options.selectedMapUpdate) {
        $scope.options.selectedMapStandard = undefined;
        $scope.options.standard1094C = undefined;
        $scope.options.selectedMapForClone = undefined;
        $scope.options.labelMapStandardName = selectAMap;
        if(importType === IMPORT.ORIGINALIMPORT && $scope.options.selectedMap){
          $scope.options.selectedMapUpdate = undefined;
        }
        else{
          if(importType === IMPORT.UPDATEIMPORT && $scope.options.selectedMapUpdate){
            $scope.options.selectedMap = undefined;
          }
        }
        var selectedMapFullInfo = findMapElement();
        callMapSetting(selectedMapFullInfo.FullName, selectedMapFullInfo.SettingName);
        if(importType === IMPORT.ORIGINALIMPORT && $scope.options.selectedMap){
          $scope.options.mapUpdEditButtonDisabled = 'true';
          $scope.options.selectedMapUpdate = undefined;
          $scope.options.labelMapName = selectedMapFullInfo.SettingName;
          $scope.options.labelMapUpdName = selectAMap;
        }
        else{
          if(importType === IMPORT.UPDATEIMPORT && $scope.options.selectedMapUpdate){
            $scope.options.mapEditButtonDisabled = 'true';
            $scope.options.selectedMap = undefined;
            $scope.options.labelMapName = selectAMap;
            $scope.options.labelMapUpdName = (selectedMapFullInfo.SettingName.substr(0,14) === SETTINGS.CORRECTIONMAPS) ? selectedMapFullInfo.SettingName.substr(14) : selectedMapFullInfo.SettingName;
          }
        }
        getMapToCheckNewEmployerSponsor(selectedMapFullInfo.FullName);
      }
      else{
        $scope.options.labelMapName = selectAMap;
        $scope.options.labelMapUpdName = selectAMap;
      }
    };

    var getMapToCheckNewEmployerSponsor = function(mapFullInfo){
      isNewEmployerSponsorMapped = 'N';
      ImportService.getMapValue(mapFullInfo).then(function(mapData){
        $scope.options.newData = (mapData.MapParams.NewData === 'false') ? mapData.MapParams.NewData : 'true';
        _.find(mapData.MapFields_X5B, function(el){
          if(el.TargetField === 'S07'){
            isNewEmployerSponsorMapped = 'Y';
          }
        });
      });
    };

    $scope.selectStandardMapName = function(){
      $scope.options.mapComboDisabled = ($scope.options.selectedMapStandard !== '' && $scope.options.selectedMapStandard !== null);
      $scope.options.mapEditButtonDisabled = 'true';
      $scope.options.mapUpdEditButtonDisabled = 'true'
      if($scope.options.selectedMapStandard) {
        $scope.options.selectedMap = undefined;
        $scope.options.selectedMapUpdate = undefined;
        $scope.options.selectedMapForClone = undefined;
        $scope.options.labelMapName = selectAMap;
        $scope.options.labelMapUpdName = selectAMap;
        var selectedMapFullInfo = findMapElement();
        $scope.options.standard1094C = (selectedMapFullInfo.SettingName === IMPORT.STANDARD1094C) ? 'true' : undefined;
        callMapSetting(selectedMapFullInfo.FullName, selectedMapFullInfo.SettingName);
        $scope.options.labelMapStandardName = selectedMapFullInfo.SettingName;
      }
      else{
        $scope.options.standard1094C = undefined;
        $scope.options.labelMapStandardName = selectAMap;
      }
    };

    $scope.selectMapForClone = function(){
      if($scope.options.selectedMapForClone){
        $scope.options.selectedMapStandard = undefined;
        $scope.options.standard1094C = undefined;
        $scope.options.selectedMap = undefined;
        $scope.options.selectedMapUpdate = undefined;
        var selectedMapFullInfo = findMapElement();
        callMapSetting(selectedMapFullInfo.FullName, selectedMapFullInfo.SettingName);
        $scope.options.labelCloneMapName = selectedMapFullInfo.SettingName;
      }
    };

    var callMapSetting = function(fullName, settingName){
      ImportService.getMapSetting(fullName, settingName).then(function(data){
        $scope.selectedMapFchar.employer = (data.Employer === undefined) ? 'false' : data.Employer;
        $scope.selectedMapFchar.participant = data.Participant;
        $scope.selectedMapFchar.form = data.Fchar;
        $scope.selectedMapFchar.newData = (data.NewData === undefined) ? 'true' : data.NewData;
      }, function(error){
        $scope.selectedMapFchar.participant = 'false';
        $scope.selectedMapFchar.form = 'false';
        console.log('Error', error);
      });
    };

    $scope.importMappingCancelCallback = function(){
      $scope.options.importPage = 'import-your-data';
    };

    $scope.importMappingSuccessCallback = function(data, mapName, newData){
      $timeout(function(){
        showMsgSuccessfully();
      });
      $scope.options.importPage = 'import-your-data';
      $scope.options.mapName = (mapName.substr(0,14) === SETTINGS.CORRECTIONMAPS) ? mapName.substr(14) : mapName;
      $scope.options.newData = newData;
      getStoredMapNames();
    };

    $scope.options.importPage = 'upload-your-file';
    $scope.uploadDirective = {
      token: $window.sessionStorage.token,
      onSuccess: function(){
        $scope.options.importPage = 'import-your-data';
      },
      onError: function(){
        showMessageFromIMport('');
      }
    };

    $scope.runTestImport = function(event){
      if($scope.options.selectedMap || $scope.options.selectedMapStandard || $scope.options.selectedMapUpdate){
        $scope.options.importResultData = [];
        $scope.options.testImportProcessing = true;
        var selectedMapFullInfo = findMapElement();
        //jscs:disable maximumLineLength
        AuxiliaryOperationsService.RenewToken().then(
          ImportService.importTest(selectedMapFullInfo.FullName, $scope.uploadDirective.filename, $scope.fileType, $scope.selectedMapFchar.participant, $scope.selectedMapFchar.form, $scope.selectedMapFchar.employer).then(function(data){
            $scope.options.importResultData = data.result;
            $scope.options.testImportProcessing = false;
          }, function(error){
            $mdDialog.hide().finally(function(){
              console.log('Error', error);
              showMessageFromIMport(error);
            });
          })
        );
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/import/modals/test-import-data.html',
          parent: angular.element(document.body),
          targetEvent: event
        });
      }
      else{
        $scope.options.mapComboDisabled = false;
      }
    };

    $scope.runImport = function(event){
      if(!($scope.options.selectedMap || $scope.options.selectedMapStandard || $scope.options.selectedMapUpdate)){
        return $scope.options.mapComboDisabled = false;
      }
      if(window.sessionStorage.taxYear === CONSTANTS.TAXYEAR2015){
        $mdDialog.show({
          controller: 'DialogController',
          templateUrl: 'app/views/import/modals/confirm-import-taxYear15.html',
          parent: angular.element(document.body),
          targetEvent: event,
          clickOutsideToClose: true
        })
        .then(function(){
          runImport(event);
        }, function(){
          $route.reload();
        });
      }
      else{
        runImport(event);
      }
    };

    var runImport = function(event){
      $scope.statusPage = false;
      $scope.options.importResultData = [];
      var selectedMapFullInfo = findMapElement();
      if($scope.selectedMapFchar.form === 'X4C'){
        ImportService
          .import1094(selectedMapFullInfo.FullName, $scope.uploadDirective.filename, $scope.fileType)
          .then(function(data){
            showImportResults(data);
          }, function(error){
            $mdDialog.hide().finally(function(){
              showMessageFromIMport(error);
            });
          });
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/import/modals/import-data-1094.html',
          parent: angular.element(document.body),
          targetEvent: event
        });
      }
      else{
        ImportService
          .importLrj(selectedMapFullInfo.FullName, $scope.uploadDirective.filename, $scope.fileType, $scope.selectedMapFchar.participant, $scope.selectedMapFchar.form, $scope.selectedMapFchar.employer)
          .then(function(data){
            $scope.jobId = data.result.DataInt;
            $scope.type = LRJ_MANAGER.JOBTYPE.IMPORT;
            $mdDialog.show({
              scope: $scope.$new(),
              templateUrl: 'app/views/import/modals/import-data.html',
              parent: angular.element(document.body),
              targetEvent: event
            });
          });
      }
    };

    var listenerFinishImport = $rootScope.$on('FINISH_IMPORT', function(event, data){
      var progressList = data.filter(function(e){
        return e.match(/^Id\: /);
      });

      var imports = [];

      progressList.forEach(function(e){
        var obj = UtilsService.getFchar(e);
        obj.newData = ($scope.options.newData === 'false') ? $scope.options.newData : 'true';
        imports.push(obj);
      });

      imports.sort(function(a, b){
        if(a.importId > b.importId){
          return 1;
        }
        if(a.importId < b.importId){
          return -1;
        }
        return 0;
      });

      ImportService.importResults(imports, $scope.uploadDirective.filename, imports[imports.length - 1].fchar).then(function(data){
        showImportResults(data);
      });
    });

    var showImportResults = function(data){
      $mdDialog.hide();
      _.each(data.result.DataList, function(element){
        element.accepted = element.accepted - element.incomplete;
        element.skipped = element.total - (element.accepted + element.rejected + element.incomplete);
      });
      $scope.options.importResultData = data.result.DataList;
      $scope.token = $window.sessionStorage.token;
      var extension = splitFname($scope.uploadDirective.filename);
      var fullExt = '.' + extension;
      var nameFile = $scope.uploadDirective.filename.replace(fullExt, '');
      var lengthPartForm = 2;
      $scope.filename = 'EXPORT~' + nameFile + '_RejectErrors.xlsx';
      $scope.showfilename = UtilsService.splitFilename(String(nameFile)) + '_RejectErrors.xlsx';
      if(data.result.DataList.length === lengthPartForm){
        if(data.result.DataList[1].rejected >>> 0){
          $scope.rejectRecords = true;
        }
      }
      if(data.result.DataList[0].rejected >>> 0){
        $scope.rejectRecords = true;
      }
      $scope.options.importPage = 'your-data-was-imported';
    };

    var listenerErrorImport = $rootScope.$on('FINISH_IMPORT_ERROR', function(event, data){
      var progressList = data
        .filter(function(e){
          return e.match(/ Error\: /);
        })
        .map(function(e){
          return 'Error: ' + e.split('Error:')[1];
        });

      var values = _.uniq(progressList).join(' - ');
      $mdDialog.hide();
      $scope.messageError = values || 'System Error';
      $scope.options.importPage = 'import-data-failed';
    });

    $scope.$on('$destroy', function(){
      listenerFinishImport();
      listenerErrorImport();
    });

    var splitFname = function(result){
      var index = result.lastIndexOf('.');
      return result.substring(index + 1);
    };
    $scope.isThereRejects = function(){
      return $scope.rejectRecords;
    };
    $scope.createNewMap = function(event){
      $scope.callImportMapping();
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/import/modals/create-new-map.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };
    $scope.editMap = function(event){
      $scope.callEditMap();
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/import/modals/edit-map.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    $scope.cloneMap = function(event){
      $scope.options.mapName = '';
      $scope.options.newData = 'true';
      $scope.options.labelCloneMapName = selectAMap;
      $scope.options.selectedMapForClone = undefined;
      $scope.errorMessage = '';
      removeMap(IMPORT.STANDARD1094C);
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/import/modals/cloneMap.html',
        parent: angular.element(document.body),
        targetEvent: event
      });
    };

    var removeMap = function(mapToRemove){
      var index;
      _.each($scope.importMapsForClone, function(map){
        if(map.SettingName === mapToRemove){
          index = $scope.importMapsForClone.indexOf(map);
        }
      });
      if(index !== undefined){
        $scope.importMapsForClone.splice(index, 1);
      }
    };

    $scope.closeModal = function(){
      $mdDialog.hide();
    };
    $scope.goImport = function(){
      $route.reload();
    };
    $scope.goRecords = function(){
      $location.path('/records');
    };
    $scope.callImportMapping = function(){
      $scope.mode = 'create';
      $scope.mapFields = [];
      $scope.options.mapName = '';
      $scope.options.formType = 'false';
      $scope.options.Participant = 'false';
      $scope.options.Employer = 'false';
      $scope.options.newData = 'true';

      ImportService.getImportSample($scope.uploadDirective.filename, $scope.fileType, '1').then(function(data){
        var sourceData = angular.fromJson(data.result.JSonSample);
        $scope.sourceFields = _.map(sourceData[0].columns, function(column){
          return {name: column.name};
        });
        $scope.options.importPage = 'import-mapping';
      }, function(error){
        console.log('Import Sampler error: ', error);
        showMessageFromIMport(error);
      });
    };
    $scope.callEditMap = function(){
      $scope.mode = 'edit';
      getFieldsMatched();
    };

    var getFieldsMatched = function(){
      var selectedMapFullInfo = findMapElement();
      $scope.mapFields = [];
      $scope.sourceFieldsFromFile = [];
      ImportService.getImportSample($scope.uploadDirective.filename, $scope.fileType, '1').then(function(data){
        var sourceData = angular.fromJson(data.result.JSonSample);
        $scope.sourceFieldsFromFile = _.map(sourceData[0].columns, function(column){
          return {name: column.name};
        });
        /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        ImportService.getMapValue(selectedMapFullInfo.FullName).then(function(mapData){
          if($scope.mode === 'edit'){
            $scope.options.mapName = (mapData.Name.substr(0,14) === SETTINGS.CORRECTIONMAPS) ? mapData.Name.substr(14) : mapData.Name;
          };
          $scope.options.formType = mapData.MapParams.Fchar;
          $scope.options.Participant = mapData.MapParams.Participant;
          $scope.options.Employer = mapData.MapParams.Employer;
          if($scope.mode !== 'clone'){
            $scope.options.newData = mapData.MapParams.NewData;
          }
          else{
            if($scope.options.newData !== 'false'){
              mapData.MapFields_1 = removeCorrectionFields(mapData.MapFields_1);
              mapData.MapFields_X5B = removeCorrectionFields(mapData.MapFields_X5B);
            }
          }
          Array.prototype.push.apply($scope.mapFields, mapData.MapFields_0);
          Array.prototype.push.apply($scope.mapFields, checkNoTinFilter(mapData.MapFields_1));
          switch($scope.options.formType){
            case 'X5B':
              Array.prototype.push.apply($scope.mapFields, mapData.MapFields_X5B);
              break;
            case 'X5C':
              Array.prototype.push.apply($scope.mapFields, mapData.MapFields_X5C);
              break;
          }
          $scope.sourceFields = [];
          Array.prototype.push.apply($scope.sourceFields, $scope.sourceFieldsFromFile);
          Array.prototype.push.apply($scope.sourceFields, _.map($scope.mapFields, function(value){
            return {name: value.SourceField};
          }));
          $scope.sourceFields = _.uniq($scope.sourceFields, 'name');
          $scope.options.importPage = 'import-mapping';
        }, function(error){
          console.log('Error', error);
        });
      }, function(error){
        console.log('Import Sampler error: ', error);
        showMessageFromIMport(error);
      });
    };

    $scope.validateMapName = function(form){
      if(!form.$valid){
        $scope.showRequiredMessage();
        return true;
      }
      if($scope.checkIfMapNameExist()){
        return true;
      }
      if(!$scope.options.selectedMapForClone){
        $scope.errorMessage = FORM_MESSAGES.SELECTONEMAP;
        return true;
      }
      $scope.errorMessage = '';
      $scope.options.labelMapStandardName = selectAMap;
      $mdDialog.hide();
      $scope.callCloneMap();
    };

    $scope.checkIfMapNameExist = function(){
      var tempName = '';
      $scope.options.mapName = $scope.options.mapName.replace(/ /g, '_');
      for(var i = 0; i < $scope.options.importMaps.length; i++) {
        tempName = ($scope.options.importMaps[i].SettingName.substr(0,14) === SETTINGS.CORRECTIONMAPS) ? $scope.options.importMaps[i].SettingName.substr(14) : $scope.options.importMaps[i].SettingName;
        if(tempName === $scope.options.mapName){
          $scope.errorMessage = FORM_MESSAGES.MAPNAMEALREADYEXISTS;
          return true;
        }
      }
      return false;
    };

    $scope.callCloneMap = function(){
      $scope.mode = 'clone';
      getFieldsMatched();
    };

    $scope.showImportTutorial = function(ev){
      $mdDialog.show({
        clickOutsideToClose: true,
        controller: 'DialogController',
        templateUrl: '/app/views/import/modals/import-video-tutorial.html',
        parent: angular.element(document.body),
        targetEvent: ev
      });
    };
    var showMsgSuccessfully = function(){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/import/modals/newMapSuccessfully.html',
        parent: angular.element(document.body)
      });
    };

    var showMessageFromIMport = function(error){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      $scope.options.importPage = 'import-data-failed';
      if(error.data.error.frontend_message !== '' && error.data.error.frontend_message !== undefined){
        $scope.messageError = error.data.error.frontend_message;
      }
      else{
        $scope.messageError = 'System Error';
      }
    };

    var removeCorrectionFields = function(fields){
      if(fields){
        fields = fields.filter(function(item){
          return (item.SourceField !== 'NEWTIN' && item.SourceField !== 'NEWEMPLOYERSPONSOR' && item.SourceField !== 'NEWORIGINOFPOLICY')
        });
      }
      return fields;
    };

    var checkNoTinFilter = function(fields){
      if(fields !== undefined){
        var index = 0;
        var amountTin = fields.filter(function(item, idx){
          if(item.SourceField === 'TIN'){
            if(item.FilterType === '' && item.FilterParams === ''){
              index = idx;
            }
            return item;
          }
        });
        if(amountTin.length > 1){
          delete fields[index];
          fields.splice(index, 1);
        }
      }
      return fields;
    };

    $scope.goToHistoryStatus = function(){
      AuxiliaryDataService.getLrjStatusList(LRJ_MANAGER.JOBTYPE.IMPORT).then(function(data){
        $scope.importFiles = data.result;
        $scope.importFiles = _.each(data.result, function(element){
          element.createdon = LayoutService.formatAMPM(element.createdon);
          element.finishedon = (element.finishedon !== undefined)
                                ? LayoutService.formatAMPM(element.finishedon)
                                : undefined;
        });
        $scope.parent = HIST_STATUS_TEXT.PARENTIMPORT;
        $scope.options.importPage = 'import-history-data';
      }, function(error){
        console.log('Error: ' + error);
      });
    };

    $scope.findJob = function(job){
      $scope.jobId = job.jobid;
      $scope.statusPage = true;
      $scope.uploadDirective.filename = job.filename;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/import/modals/import-data.html',
        parent: angular.element(document.body)
      });
    };

    $scope.goToSelectMyFiles = function(){
      RFMService.getFilesToImport().then(function(data){
        $scope.filesList = data.result;
        $scope.filesList.forEach(function(part, index, theArray){
          theArray[index].createdon = UtilsService.getUnixTimestamp(part.createdon);
        });
        $mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/import/modals/select-my-files.html',
          parent: angular.element(document.body)
        });
      });
    };

    $scope.onOrderChange = function(order){
      if(order === 'showname'){
        $scope.filesList = $filter('orderBy')($scope.filesList, order);
      }
      else{
        const copyFileslist = JSON.parse(JSON.stringify($scope.filesList));
        const arrayListToOrder = copyFileslist.map(function(element){
          element.createdonOrder = new Date(element.createdon).getTime();
          return element;
        });
        $scope.filesList = $filter('orderBy')(arrayListToOrder, order);
      }  
    };
    
    $scope.selectedFileByUser = function(fileName, fullFileName){
      $mdDialog.hide();
      $scope.fileType = '~' + fullFileName.slice(0, fullFileName.lastIndexOf('~')) + '~';
      $scope.uploadDirective.filename = fileName;
      $scope.uploadDirective.extension = getFileExtension();
      $scope.uploadDirective.onSuccess();
    };

    var getFileExtension = function(){
      if(!$scope.uploadDirective.filename.match(/\./)){
        return ;
      }
      return $scope.uploadDirective.filename.split('.').pop().toLowerCase();
    };

    $scope.showRequiredMessage = function(){
      $scope.showRequired = true;
    };
  }
]);
